// extracted by mini-css-extract-plugin
module.exports = {"group":"MostSearched_group__21Jzs","group-links":"MostSearched_group-links___pfJS","link":"MostSearched_link__oWDSt"};